import React from "react";
import { SectionHeader, SelectField, ReadOnlyField, InfoNote } from "../primitives";
import { selectionKey } from "../data";
import { colors } from "../../../utils/styles";

// `options` come from data.js reshapeJurisdictionRows — a flat list of
// dropdown choices. Each option carries its own `selection`, `label`, and
// `address`, so this step only has to render them.
export default function AgencyInfoStep({ selection, onSelectionChange, options = [], loaded = false }) {
  const selectedKey = selectionKey(selection);
  const selected = options.find((o) => o.key === selectedKey);

  return (
    <div>
      <SectionHeader
        number="1"
        title="Parent Agency Information"
        subtitle="Select the parent agency filing this notification"
      />
      <div style={{ display: "grid", gap: 20 }}>
        <SelectField
          label="Parent Agency Name"
          required
          path="selection"
          value={selectedKey}
          onChange={(e) => {
            const next = options.find((o) => o.key === e.target.value);
            onSelectionChange(next ? next.selection : null);
          }}
          options={options.map((o) => ({ value: o.key, label: o.label }))}
          placeholder={
            !loaded
              ? "Loading..."
              : options.length
                ? "Select parent agency..."
                : "No parent agencies available for your access"
          }
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <ReadOnlyField label="Address" value={selected?.address} />
          <InfoNote>
            Contact Property Tax at{" "}
            <a
              href="mailto:ptassessments@sbcountyatc.gov"
              style={{
                color: colors.navy,
                fontWeight: 700,
                textDecoration: "underline",
                textUnderlineOffset: "2px"
              }}
            >
              ptassessments@sbcountyatc.gov
            </a>{" "}
            if address needs to be changed.
          </InfoNote>
        </div>
      </div>
    </div>
  );
}
